import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue';
import ProjetsView from '../views/ProjetsView.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },

  {
    path: '/works',
    name: 'works',
    component: ProjetsView,
  },

  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // Scrolle la page jusqu'au debut
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' }
  }
})

router.beforeResolve((to, _from, next) => {
  next()
})

export default router
